import type { IDialog, IDialogMessage } from '../../dialog/interface';

export interface IModuleDialog {
    isShowing: () => boolean;
    show: () => void;
    hide: () => void;
    updateCallbacks: (args: { onAccept?: () => void; onDecline?: () => void }) => void;
    updateText: (args: { title?: string; textAccept?: string; textDecline?: string }) => void;
}

const DEFAULTS_MESSAGE: Required<IDialogMessage> = {
    id: 'Dialog-Message',
    show: true,
    title: '',
    textAccept: '',
    textDecline: '',
    onAccept: () => {
        /* No-Op */
    },
    onDecline: () => {
        /* No-Op */
    },
    options: { removeOnHide: true },
};

function ModuleDialog(defaults: Partial<IDialogMessage>, dialog: IDialog): IModuleDialog {
    if (!dialog) {
        throw new Error(`Download-Language: Missing dialog object`);
    }

    const message: Required<IDialogMessage> = {
        ...DEFAULTS_MESSAGE,
        ...defaults,
    };

    return {
        show: () => {
            dialog.show(message);
        },
        hide: () => {
            if (dialog.isShowing(message)) {
                dialog.hide(message);
            }
        },
        isShowing: () => dialog.isShowing(message),
        updateText: args => {
            Object.assign(message, args);
        },
        updateCallbacks: args => {
            Object.assign(message, args);
        },
    };
}

export default ModuleDialog;
